import { useEffect, useState } from "react";
import { Main } from "@/components/Main";
import { PageHeader } from "@/components/PageHeader";
import { CreateLoaderTable } from "@/components/Loaders";
import { getPendingForReview } from "@/Api/timeEntryAdjustmentRequests";
import { TimeEntryTypeLabel } from "@/types/timeEntry";
import { DecideAdjustmentRequestBtns } from "@/App/TimeEntryAdjustmentRequests/Decide";
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from "@/components/ui/table";
import { ClipboardCheck } from "lucide-react";
import { usePermissions } from "@/hooks/usePermissions";
import { If } from "@/components/If";
import { UnityFilter, useUnityFilter } from "@/components/UnityFilter";

export const PageList = () => {
  const [listData, setListData] = useState<any>({});
  const [state, setState] = useState("loading");
  const { hasPermission } = usePermissions();
  const unityFilter = useUnityFilter();

  const fetchData = async () => {
    setState("loading");
    const { data } = await getPendingForReview(1, unityFilter.param, unityFilter.nameParam);
    setListData(data?.response ?? {});
    setState("production");
  };

  useEffect(() => {
    if (!unityFilter.ready) return;
    fetchData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [unityFilter.ready, unityFilter.param, unityFilter.nameParam]);

  return (
    <Main>
      <If condition={hasPermission("create-time-entry-adjustment")}>
        <PageHeader
          icon={ClipboardCheck}
          title="Solicitações de Ajuste de Ponto"
          description="Analise as solicitações de correção abertas pelos colaboradores"
        />

        <UnityFilter
          filter={unityFilter}
          className="mb-3"
          namePlaceholder="Buscar por colaborador"
        />

        {state === "loading" ? (
          <CreateLoaderTable cols={4} lines={6} />
        ) : (
          <Table className="bg-zinc-50 rounded dark:bg-[#2c2c2c]">
            <TableHeader>
              <TableRow>
                <TableHead>Colaborador</TableHead>
                <TableHead>Tipo</TableHead>
                <TableHead>Data/Horário solicitado</TableHead>
                <TableHead>Justificativa</TableHead>
                <TableHead className="text-center">Ações</TableHead>
              </TableRow>
            </TableHeader>
            <TableBody>
              {listData?.data?.map((item: any) => (
                <TableRow key={item.uuid}>
                  <TableCell>{item.employee?.user?.name}</TableCell>
                  <TableCell>
                    {TimeEntryTypeLabel[item.time_entry_type_id]}
                  </TableCell>
                  <TableCell>
                    {new Date(item.requested_date).toLocaleDateString("pt-BR", { timeZone: "UTC" })}{" "}
                    às {item.requested_time}
                  </TableCell>
                  <TableCell className="truncate max-w-80">
                    {item.justification}
                  </TableCell>
                  <TableCell className="flex justify-center">
                    <DecideAdjustmentRequestBtns
                      uuid={item.uuid}
                      onDecided={fetchData}
                    />
                  </TableCell>
                </TableRow>
              ))}
              {(!listData?.data || listData.data.length < 1) && (
                <TableRow>
                  <TableCell colSpan={5}>
                    Nenhuma solicitação pendente.
                  </TableCell>
                </TableRow>
              )}
            </TableBody>
          </Table>
        )}
      </If>
    </Main>
  );
};

export default PageList;
